<template>
  <div class="c-select_wrap">
    <select
      v-model="selectedArtistId"
      class="form-control c-select"
      style="width: 300px">
      <option
        v-for="(artist, index) in availableArtists"
        :key="index"
        :value="artist.id">
        {{ artist.name }}
      </option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'ArtistSelector',
  components: {
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      selectedArtistId: null,
      menuShown: false,
      artists: [],
    }
  },
  computed: {
    availableArtists() {
      return [{ id: null, name: 'すべて' }, ...this.artists]
    },
  },
  watch: {
    selectedArtistId: {
      handler(selectedArtistId) {
        this.$emit('input', selectedArtistId)
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const response = await window.axios.get('/api/client/reports/all-artists?type=1&count=9999')
      this.artists = response.data
    },
  },
}
</script>
